import btoa from 'btoa-lite';
import { useMocks } from './mocks';
let appAuthentication;
export function setAppAuthentication(authentication) {
    if (!authentication) {
        appAuthentication = authentication;
    }
    else {
        const { username, password } = authentication;
        if (username && password) {
            appAuthentication = authentication;
        }
    }
}
/**
 * If mocks are enabled and a mockId is defined, all service requests are proxied through
 * the app server and its mocks router. Therefore the app authentication (if defined) must
 * be used for those requests. Otherwise the service authentication (if defined) is returned.
 */
function getAuthentication(serviceOptions = {}, mockConfig = {}) {
    return useMocks(mockConfig)
        ? appAuthentication
        : serviceOptions.authentication;
}
export function getAuthorizationHeader(serviceOptions = {}, mockConfig = {}) {
    const authentication = getAuthentication(serviceOptions, mockConfig);
    if (authentication &&
        authentication.hasOwnProperty('username') &&
        authentication.hasOwnProperty('password')) {
        const { username, password } = authentication;
        const payload = `${username}:${password}`;
        return `Basic ${btoa(payload)}`;
    }
    return;
}
